/**
 * Basis-Klasse für Such-Funktionen
 *
 * @class SP.sitekit.search.SearchController
 */
SP.lang.Class.define("SP.sitekit.search.SearchController", {

	_el: null,

	_form: null,

	_data: null,

	_loaderEl: null,

	_searchDelay: 200,

	// für Fokus Management
	_activeElementId: null,

	_throttledReloadResultSets: null,

	/**
	 * Konstruktor
	 */
	init: function(el, data) {
		this._el = el;
		this._data = data;
		this._form = el.querySelector("form");

		this._registerFormEventListener();
		this._registerSearchResultEventListeners();

		var resultSets = document.getElementById(this._data.elementIdBase + "-resultSets");
		this._loaderEl = document.createElement("div");
		this._loaderEl.classList.add("SP-Loader");
		resultSets.parentElement.replaceChild(this._loaderEl, resultSets);
		this._loaderEl.appendChild(resultSets);

		// bei History-Back die Seite neu laden
		window.addEventListener("popstate", function(popStateEvent) {
			if (popStateEvent.state && popStateEvent.state.isSectionSearch) {
				location.reload();
			}
		});

		this._throttledReloadResultSets = SP.lang.Function.throttle(this._reloadResultSets, 500);
	},

	/**
	 * Id vom aktuell fokussieren Element spreichern
	 */
	_saveCurrentFocus: function () {
		// fokussiertes Element zwischenspeichern
		this._activeElementId = null;
		if (document.activeElement) {
			this._activeElementId = document.activeElement.id;
		}
	},

	/**
	 * Fokus wiederherstellen
	 */
	_restoreFocus: function () {
		if (this._activeElementId) {
			var activeEl = this._el.querySelector("#" + this._activeElementId);
			if (activeEl) {
				activeEl.focus({
					preventScroll: true
				});
			}
		}
	},

	/**
	 * Dieser Listener muss nur 1x initial registriert werden, da das Fragment nicht ausgetauscht wird
	 */
	_registerFormEventListener: function () {
		this._registerSearchChangeListener();
		this._registerDateBlurListener();
	},

	_registerSearchChangeListener: function () {
		var me = this;

		// Change Listener für Text, Select, etc außer Datum-Eingabe-Felder
		me._el.addEventListener("change", SP.lang.Function.debounce(function(e) {
			// auf Change-Events vom Date-Input nicht hören, da sonst Suchen vor dem Ende einer Datums-Eingabe erfolgen & der Fokus verloren geht
			if (e.target.type && e.target.type.toLowerCase() !== "date") {
				me._processChangeEvent(e);
			}
		}, me._searchDelay));
	},

	_registerDateBlurListener: function () {
		// Blur Listener für Datum-Eingabe-Felder
		var dateFields = this._el.querySelectorAll("input[type='date']");
		if (dateFields !== null && dateFields.length > 0) {
			for (var i = 0; i < dateFields.length; i++) {
				var dateField = dateFields[i];
				dateField.addEventListener("blur", this._processChangeEvent.bind(this), false);
			}
		}
	},

	_registerSearchResultEventListeners: function() {

		var me = this;

		// Click-Events
		var resultSets = document.getElementById(me._data.elementIdBase + "-resultSets");
		resultSets.parentElement.addEventListener("click", function(e) {
			me._processClickEvent(e);
		});

		resultSets.addEventListener("pagination", function(e) {
			var pagination = e.detail[0];
			me._storeState(pagination);
			me._throttledReloadResultSets(null, true, pagination);
		});
	},

	_processChangeEvent: function(e) {
		var me = this;

		me._saveCurrentFocus();

		var categorySelect = SP.dom.ElementStream.create(e.target).parent("[data-sp-form-search-categoryselect]").get();
		me._reloadAllCategorySelect(categorySelect);

		// nur wenn die "Zeitraum"-Selectbox ein Change-Event generiert muss die Date-Composition ausgetauscht werden
		if (me._isTriggeredByDateRangeSelect(e)) {
			me._reloadDateComposition();
		}

		if (me._data.submitOnChange === true) {
			me._reloadResultSets();

			var formData = new FormData(me._form);
			formData.append("action", "submit");

			me._storeState();
		}
	},

	/**
	 * Ist das Event-Target die "Zeitraum"-Selectbox?
	 */
	_isTriggeredByDateRangeSelect: function (event) {
		return event.target.id === this._data.elementIdBase + "-dateRange-input";
	},

	_reloadDateComposition: function () {
		var dateComp = this._el.querySelector("[data-sp-dateselectorcomposition]");
		if (dateComp && dateComp.id) {
			var me = this;
			var form = me._el.querySelector("form");
			if (form) {
				var formData = new FormData(form);
				formData.append("sp:out", "htmlFragment");
				formData.append("component", me._data.component);
				formData.append("formFragment", dateComp.id);
				formData.append("action", "submit");
				SP.net.http.Client.fetch(document.location.pathname, { method: "POST", body: formData })
					.then(function(xhr, response) {
						SP.dom.Element.replace(dateComp, response);
						me._restoreFocus();
					}).catch(function(e, xhr, response) {
						console.error(e);
					});
			}
		}
	},

	_getPaginationParameters: function (excludePageParameter) {
		var paginationParams = {};
		var queryParameters = this._parseQuery(location.search);
		SP.lang.Object.each(queryParameters, function (key, value) {
			if (key.indexOf("sp:page") !== -1 && (excludePageParameter === undefined || key !== excludePageParameter)) {
				paginationParams[key] = value;
			}
		});
		return paginationParams;
	},

	_parseQuery: function (queryString) {
		var query = {};
		var pairs = (queryString[0] === "?" ? queryString.substr(1) : queryString).split("&");
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i].split("=");
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
		}
		return query;
	},

	_storeState: function (pagination) {
		var formData = new FormData(this._form || undefined);
		if (pagination) {
			formData.set(pagination.pageParameterName, pagination.page);

			var otherPaginationParams = this._getPaginationParameters(pagination.pageParameterName);
			SP.lang.Object.each(otherPaginationParams, function (key, value) {
				formData.set(key, value);
			});
		}
		var serialized = SP.sitekit.Form.encodeURIFormData(formData);
		history.pushState({ isSectionSearch : true }, document.title, window.location.pathname + "?" + serialized + "&action=submit");
	},

	_processClickEvent: function(e) {
		var me = this;

		var submitButton = null;
		if (e.target.getAttribute("data-sp-search-form-submitButton") !== null) {
			submitButton = e.target;
		} else {
			submitButton = SP.dom.Element.closest(e.target, "[data-sp-search-form-submitButton]");
		}

		var paginationLink = null;
		if (e.target.getAttribute("data-sp-search-result-pagination-link") !== null) {
			paginationLink = e.target;
		} else {
			paginationLink = SP.dom.Element.closest(e.target, "[data-sp-search-result-pagination-link]");
		}

		if (paginationLink !== null) {
			if (paginationLink.tagName !== "A") {
				paginationLink = paginationLink.querySelector("A");
			}
		}

		// Submit-Button wurde geklickt
		if (submitButton !== null) {
			e.stopPropagation();
			e.preventDefault();
			me._storeState();
			this._reloadResultSets(false, true);
		}

		// handling für die "Standard-Pagination", die ohne Slider
		if (paginationLink !== null) {
			e.stopPropagation();
			e.preventDefault();
			var href = paginationLink.getAttribute("href");
			var params = href.substring(href.indexOf("?") + 1);
			me._reloadResultSets(params, true);
			history.pushState(null, null, window.location.pathname + "?" + params);
		}
	},

	_categoryChanged: function(container, select) {
		this._reloadCategorySelect(container, select);
		this._reloadResultSets();
	},

	_reloadAllCategorySelect: function(focusSelect) {
		var me = this;
		var categorySelections = this._el.querySelectorAll("[data-sp-form-search-categoryselect]");
		SP.lang.Array.each(categorySelections, function(i, categorySelect) {
			me._reloadCategorySelect(categorySelect, focusSelect);
		});
	},

	_reloadCategorySelect: function(container, select) {

		var me = this;

		var resetFocus = true;
		if (!SP.isDefined(select) || select === null) {
			select = container.querySelector("select");
			resetFocus = false;
		}

		var containerData = JSON.parse(container.getAttribute("data-sp-form-search-categoryselect"));

		var form = me._el.querySelector("form");

		if (form) {
			var formData = new FormData(form);
			formData.append("sp:out", "htmlFragment");
			formData.append("component", me._data.component);
			formData.append("formFragment", containerData.id);
			formData.append("action", "submit");

			SP.net.http.Client.fetch(document.location.pathname, { method: "POST", body: formData })
				.then(function(xhr, response) {
					SP.dom.Element.replace(container, response);
					me._restoreFocus();
				}).catch(function(e, xhr, response) {
					console.error(e);
				});
		}
	},

	_reloadResultSets: function(params, scrollIntoView, pagination) {
		var me = this;

		var url;
		var options = null;
		var form = me._el.querySelector("form");

		if (!params && form) {
			var formData = new FormData(form);
			formData.append("sp:out", "htmlFragment");
			formData.append("processComponents[]", me._data.component);
			if (me._data.processComponents) {
				me._data.processComponents.forEach(function(value) {
					formData.append("processComponents[]", value);
				});
			}
			formData.append("component", me._data.component + "-resultSets");
			formData.append("action", "submit");
			if (pagination) {
				var otherPaginationParams = me._getPaginationParameters(pagination.pageParameterName);
				SP.lang.Object.each(otherPaginationParams, function (key, value) {
					formData.append(key, value);
				});
				formData.append(pagination.pageParameterName, pagination.page);
			}
			options = { method: "POST", body: formData };
			url = document.location.pathname;
		} else {
			var additionalParams = [];
			additionalParams.push("sp:out=htmlFragment");
			if (me._data.processComponents) {
				me._data.processComponents.forEach(function(value) {
					additionalParams.push("processComponents[]=" + encodeURIComponent(value));
				});
			}
			additionalParams.push("processComponents[]=" + encodeURIComponent(me._data.component));
			additionalParams.push("component=" + encodeURIComponent(me._data.component + "-resultSets"));
			additionalParams.push("action=submit");
			var queryString = "?";
			if (pagination) {
				queryString = queryString + "&" + pagination.pageParameterName + "=" + pagination.page + "&";
			}
			if (params) {
				queryString = queryString + params + "&";
			}
			queryString = queryString + additionalParams.join("&");
			url = document.location.pathname + queryString;
		}

		var resultSets = document.getElementById(me._data.elementIdBase + "-resultSets");
		if (scrollIntoView === true) {
			window.scroll({
				top: (window.scrollY || window.pageYOffset) + resultSets.getBoundingClientRect().top,
				left: 0,
				behavior: "smooth"
			});
		}

		me._loaderEl.classList.add("SP-isLoading");

		SP.net.http.Client.fetch(url, options)
			.then(function(xhr, response) {
				SP.dom.Element.replace(resultSets, response);
				me._loaderEl.classList.remove("SP-isLoading");
				me._registerSearchResultEventListeners();
				me._firePagintionFinishedEvent();
			}).catch(function(e, xhr, response) {
				console.error(e);
				me._loaderEl.classList.remove("SP-isLoading");
			});
	},

	/**
	 * TODO: auf TS refactorn => https://github.com/Stanko/animated-scroll-to
	 * windows.scroll meldet nicht wenn zu ende gescrollt wurde, daher dieser Workaround
	 */
	_firePagintionFinishedEvent : function () {
		var me = this;
		setTimeout(function () {
			SP.dom.Event.fireEvent(me._el, "paginationFinished", [{source: "siteSearch"}], true);
		}, 1000);
	}
});